import CasesIndex from './CasesIndex';

export default CasesIndex;
